import { render } from "./setSort.vue?vue&type=template&id=efe9656e&scoped=true"
import script from "./setSort.vue?vue&type=script&lang=js"
export * from "./setSort.vue?vue&type=script&lang=js"

import "./setSort.vue?vue&type=style&index=0&id=efe9656e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe9656e"],['__file',"src/views/brand/components/setSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "efe9656e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('efe9656e', __exports__)) {
    console.log('reload')
    api.reload('efe9656e', __exports__)
  }
  
  module.hot.accept("./setSort.vue?vue&type=template&id=efe9656e&scoped=true", () => {
    console.log('re-render')
    api.rerender('efe9656e', render)
  })

}


export default __exports__